export default "__VITE_ASSET__DfwL04Dk__"